import { Link } from "react-router-dom";
import { Instagram, MapPin, Star } from "lucide-react";
import { SERVICE_AREA, INSTAGRAM_URL, INSTAGRAM_HANDLE, GOOGLE_BUSINESS_URL, MEDIA, TIKTOK_URL, TIKTOK_HANDLE } from "../data/site";

export const TikTokIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
    </svg>
);

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-[#2D230A] text-[#FAF7F2] mt-0">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16 sm:py-20 grid gap-12 md:grid-cols-3">
            <div>
                <img
                    src={MEDIA.logo}
                    alt="Enchanting Escapes logo"
                    className="h-16 sm:h-20 w-auto mb-5"
                />
                <p className="text-[#FAF7F2]/70 leading-relaxed text-sm">
                    Luxury picnic and outdoor event styling in McKinney, Texas — serving
                    proposals, bridal showers, birthdays, anniversaries and date nights
                    across the Dallas-Fort Worth area.
                </p>
                <div className="flex flex-col gap-3 mt-6">
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-instagram-link"
                        className="flex items-center gap-2 text-[#E8C4C1] hover:text-[#FFD2CE] transition-colors font-accent text-xs uppercase tracking-widest"
                    >
                        <Instagram className="w-4 h-4" /> {INSTAGRAM_HANDLE}
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-tiktok-link"
                        className="flex items-center gap-2 text-[#E8C4C1] hover:text-[#FFD2CE] transition-colors font-accent text-xs uppercase tracking-widest"
                    >
                        <TikTokIcon className="w-4 h-4" /> {TIKTOK_HANDLE}
                    </a>
                </div>
                <a
                    href={GOOGLE_BUSINESS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-google-business-link"
                    className="mt-3 inline-flex items-center gap-2 text-[#E8C4C1] hover:text-[#FFD2CE] transition-colors font-accent text-xs uppercase tracking-widest"
                >
                    <Star className="w-4 h-4" /> Google Business Profile
                </a>
            </div>

            <div>
                <h3 className="font-accent text-xs uppercase tracking-[0.2em] text-[#E8C4C1] mb-5">
                    Explore
                </h3>
                <ul className="space-y-3 text-sm">
                    {[
                        ["Home", "/"],
                        ["Gallery", "/gallery"],
                        ["Packages", "/packages"],
                        ["About", "/about"],
                        ["FAQ", "/faq"],
                        ["Book Now", "/book"],
                    ].map(([label, path]) => (
                        <li key={path}>
                            <Link
                                to={path}
                                className="text-[#FAF7F2]/70 hover:text-[#FFD2CE] transition-colors"
                            >
                                {label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            <div>
                <h3 className="font-accent text-xs uppercase tracking-[0.2em] text-[#E8C4C1] mb-5">
                    Service Area
                </h3>
                <p className="flex items-start gap-2 text-sm text-[#FAF7F2]/70 mb-3">
                    <MapPin className="w-4 h-4 mt-0.5 shrink-0" /> Based in McKinney, Texas
                </p>
                <p className="text-sm text-[#FAF7F2]/70 leading-relaxed">
                    {SERVICE_AREA.join(" · ")} and surrounding DFW cities.
                </p>
            </div>
        </div>
        <div className="border-t border-[#FAF7F2]/10 py-6 text-center text-xs text-[#FAF7F2]/50 font-accent tracking-widest uppercase">
            © {new Date().getFullYear()} Enchanting Escapes · McKinney, TX · Dallas-Fort Worth
        </div>
    </footer>
);
